import { useEffect, useState } from "react";

function getInitial(query, fallback) {
  if (typeof window === "undefined" || !window.matchMedia) return fallback;
  return window.matchMedia(query).matches;
}

function getSaveDataInitial() {
  if (typeof navigator === "undefined") return false;
  return Boolean(navigator.connection && navigator.connection.saveData);
}

export function useMotionPreferences() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() =>
    getInitial("(prefers-reduced-motion: reduce)", false),
  );
  const [prefersSaveData, setPrefersSaveData] = useState(getSaveDataInitial);
  const [isSmallViewport, setIsSmallViewport] = useState(() =>
    getInitial("(max-width: 768px)", false),
  );

  useEffect(() => {
    const motionMql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const viewportMql = window.matchMedia("(max-width: 768px)");
    const onMotion = (e) => setPrefersReducedMotion(e.matches);
    const onViewport = (e) => setIsSmallViewport(e.matches);
    motionMql.addEventListener("change", onMotion);
    viewportMql.addEventListener("change", onViewport);

    let conn;
    const onConnChange = () =>
      setPrefersSaveData(Boolean(navigator.connection?.saveData));
    if (navigator.connection?.addEventListener) {
      conn = navigator.connection;
      conn.addEventListener("change", onConnChange);
    }

    return () => {
      motionMql.removeEventListener("change", onMotion);
      viewportMql.removeEventListener("change", onViewport);
      if (conn?.removeEventListener) conn.removeEventListener("change", onConnChange);
    };
  }, []);

  return {
    prefersReducedMotion,
    prefersSaveData,
    isSmallViewport,
    enableHeavyMotion: !prefersReducedMotion && !prefersSaveData && !isSmallViewport,
  };
}
